import { createFormHook, createFormHookContexts } from "@tanstack/react-form";

import { CheckboxField } from "./components/CheckboxField";
import { DateField } from "./components/DateField";
import { FileField } from "./components/FileField";
import { InputField } from "./components/InputField";
import { SelectField } from "./components/SelectField";
import { SubmitButton } from "./components/SubmitButton";
import { TextAreaField } from "./components/TextAreaField";

export { useStore as useFormStore } from "@tanstack/react-form";

// Create and export contexts
export const { fieldContext, useFieldContext, formContext, useFormContext } =
  createFormHookContexts();

// Create form hook with components
export const { useAppForm, withForm } = createFormHook({
  fieldComponents: {
    CheckboxField,
    DateField,
    FileField,
    InputField,
    TextAreaField,
    SelectField,
  },
  formComponents: {
    SubmitButton,
  },
  fieldContext,
  formContext,
});
